<template lang="html">
	<div class="header-container">
		<div class="Yarn_Background" style="background-image: url( ../../static/images/47fb3c_.jpg);"></div>
        <div class="search-form search-form--modal" :class="{'is-visible': searchFormShow}" @click="searchArticle"></div>
        <div class="search-form" v-if="searchFormShow">
            <div class="search-form__inner">
                <div>
                    <div id="search-container" class="ajax_search">
                        <div class="filter_container">
                            <input type="text" v-model="keyWord" autocomplete="off" placeholder="Type the keyword" name="keyword" v-on:keyup.enter="doSearch"/>
                            <ul id="search_filtered" class="search_filtered"></ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

		<div class="navi aos-init aos-animate" data-aos="fade-down"  :class="{'open': !menuOpen, 'close':menuOpen}">
			<div class="bt-nav" @click="toggleMenu">
				<div class="line line1"></div>
				<div class="line line2"></div>
				<div class="line line3"></div>
			</div>
			<div class="navbar animated fadeInRight">
				<div class="inner">
					<nav id="site-navigation" class="main-navigation">
						<div id="main-menu" class="main-menu-container">
							<div class="menu-menu-container">
								<ul id="primary-menu" class="menu">
									<li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home">
                                        <router-link to="/">首页</router-link>
									</li>
									<li class="menu-item menu-item-type-post_type menu-item-object-page">
                                        <router-link to="/flink">友链</router-link>
									</li>
									<li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children" :class="{'open-page-item': openArchives}">
                                        <a href="javascript:void(0)" @click="toggleArchives">归档</a>
										<ul class="sub-menu">
                                            <header-archives v-for="archive in archives" :id="archive.id" :name="archive.name"></header-archives>
										</ul>
                                        <span class="menu-dropdown" @click="toggleArchives"><i class="iconfont">&#xe619;</i></span>
									</li>
                                    <li class="menu-item menu-item-type-post_type menu-item-object-page">
                                        <router-link to="/aboutme">关于我</router-link>
                                    </li>
								</ul>
							</div>
						</div>
					</nav>
					<!-- #site-navigation -->
				</div>
			</div>
		</div>
		<div class="hebin" data-aos="fade-down">
			<i class="iconfont" @click="searchArticle">&#xe60e;</i>
		</div>
		<header id="masthead" class="overlay animated from-bottom" itemprop="brand">
			<div class="site-branding text-center">
                <figure>
                    <router-link to="/"><img class="custom-logo avatar" src="../../static/images/omikron.png" /></router-link>
                </figure>
				<h3 class="blog-description"><p>Talk is cheap</p></h3>
			</div>
			<!-- .site-branding -->
			<div class="decor-part">
				<div id="particles-js"></div>
			</div>
			<div class="animation-header">
				<div class="decor-wrapper">
					<svg id="header-decor" class="decor bottom" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" preserveAspectRatio="none">
						<path class="large left" d="M0 0 L50 50 L0 100" fill="rgba(255,255,255, .1)"></path>
						<path class="large right" d="M100 0 L50 50 L100 100" fill="rgba(255,255,255, .1)"></path>
						<path class="medium left" d="M0 100 L50 50 L0 33.3" fill="rgba(255,255,255, .3)"></path>
						<path class="medium right" d="M100 100 L50 50 L100 33.3" fill="rgba(255,255,255, .3)"></path>
						<path class="small left" d="M0 100 L50 50 L0 66.6" fill="rgba(255,255,255, .5)"></path>
						<path class="small right" d="M100 100 L50 50 L100 66.6" fill="rgba(255,255,255, .5)"></path>
						<path d="M0 99.9 L50 49.9 L100 99.9 L0 99.9" fill="rgba(255,255,255, 1)"></path>
						<path d="M48 52 L50 49 L52 52 L48 52" fill="rgba(255,255,255, 1)"></path>
					</svg>
				</div>
			</div>
		</header>
	</div>
</template>
<script>
    import headerArchives from './headerArchives'

	export default {
		name: "vHeader",
        inject: ["reload"],
        data: function(){
		    return {
                archives:[],
                searchFormShow: false,
                keyWord: "",
                menuOpen: false,
                openArchives: false
            }
        },
        components: {
            headerArchives
        },
        created: function(){
		    this.$http.get("/classify", {}, (res) => {
		        if(res.status){
                    this.archives = res.data;
                }else{
		            console.log(res.msg);
                }
            })
        },
        methods: {
            searchArticle: function(){
                this.searchFormShow = !this.searchFormShow;
            },
            doSearch: function(){
                this.searchFormShow = false;
                this.$router.push({path: '/', query: {keyWord:this.keyWord}});
                this.keyWord = "";
            },
            toggleMenu: function(){
                this.menuOpen = !this.menuOpen;
            },
            toggleArchives: function(){
                this.openArchives = !this.openArchives;
            }
        }
	}
</script>



// WEBPACK FOOTER //
// src/components/header.vue